import { Temporal } from "temporal-polyfill";

export const useTemporal = () => {
  const now = () => Temporal.Now.instant();

  return { now };
};
